import { call, put, takeLeading } from 'redux-saga/effects'
import { fatafatDollarActions } from '../reducer/fatafat-dollar';
import FatafatDollarAPI from '../api/fatafat-dollar-api';

function* reqFatafatDollarGames({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.getAllFatafatDollarGames, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.fatafatDollarGamesRes(res))
    } else {
        yield put(fatafatDollarActions.fatafatDollarGamesFailed(res))
    }
}

function* reqFatafatDollarGameRates({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.getFatafatDollarGameRates, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.fatafatDollarGameRatesRes(res))
    } else {
        yield put(fatafatDollarActions.fatafatDollarGameRatesFailed(res))
    }
}

function* reqFatafatDollarGameTypes({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.getFatafatDollarGameTypes, payload);
    console.log('🔵 Saga - Game Types Response:', res);
    if(res.status === 'success'){
        console.log('✅ Saga - Game Types Success, data:', res.res);
        yield put(fatafatDollarActions.fatafatDollarGameTypesRes(res))
    } else {
        console.log('❌ Saga - Game Types Failed:', res);
        yield put(fatafatDollarActions.fatafatDollarGameTypesFailed(res))
    }
}

function* reqFatafatDollarGameStatus({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.checkFatafatDollarGameStatus, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.fatafatDollarGameStatusRes(res))
    } else {
        yield put(fatafatDollarActions.fatafatDollarGameStatusFailed(res))
    }
}

function* reqSubmitFatafatDollarBid({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.submitFatafatDollarBid, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.submitFatafatDollarBidRes(res))
    } else {
        yield put(fatafatDollarActions.submitFatafatDollarBidFailed(res))
    }
}

function* reqFatafatDollarBidHistory({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.getFatafatDollarBidHistory, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.fatafatDollarBidHistoryRes(res))
    } else {
        yield put(fatafatDollarActions.fatafatDollarBidHistoryFailed(res))
    }
}

function* reqFatafatDollarWinningHistory({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.getFatafatDollarWinningHistory, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.fatafatDollarWinningHistoryRes(res))
    } else {
        yield put(fatafatDollarActions.fatafatDollarWinningHistoryFailed(res))
    }
}

function* reqFatafatDollarResults({ payload }: any): any {    
    const res = yield call(FatafatDollarAPI.getFatafatDollarResults, payload);
    if(res.status === 'success'){
        yield put(fatafatDollarActions.fatafatDollarResultsRes(res))
    } else {
        yield put(fatafatDollarActions.fatafatDollarResultsFailed(res))
    }
}

function* fatafatDollarSaga(){
    yield takeLeading('fatafatdollar/fatafatDollarGamesReq', reqFatafatDollarGames);   
    yield takeLeading('fatafatdollar/fatafatDollarGameRatesReq', reqFatafatDollarGameRates);   
    yield takeLeading('fatafatdollar/fatafatDollarGameTypesReq', reqFatafatDollarGameTypes);   
    yield takeLeading('fatafatdollar/fatafatDollarGameStatusReq', reqFatafatDollarGameStatus);   
    yield takeLeading('fatafatdollar/submitFatafatDollarBidReq', reqSubmitFatafatDollarBid);   
    yield takeLeading('fatafatdollar/fatafatDollarBidHistoryReq', reqFatafatDollarBidHistory); 
    yield takeLeading('fatafatdollar/fatafatDollarWinningHistoryReq', reqFatafatDollarWinningHistory);   
    yield takeLeading('fatafatdollar/fatafatDollarResultsReq', reqFatafatDollarResults);   
}

export default fatafatDollarSaga

